<template>
    <button :class="{'small': small === true, 'raised': raised}" @click="click" :disabled="disabled" v-if="visible !== false">
        <i v-if="icon" :class="[icon, iconColor]" class="fa fa-color" aria-hidden="true" ></i>
        {{ model }}
    </button>
</template>
<script>
    export default {
        name: 'PsButton',
        props: ['disabled', 'visible', 'model', 'icon', 'iconColor', 'small', 'raised'],
        methods: {
            click () {
                this.$emit('click')
            }
        },
        data () {
            return {}
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    button {
        min-width: 26px;
        margin-right: 4px;
        height: 32px;
        border: 1px solid #999;
        background: #DDD;
        font-size: 14px;
        padding-left: 10px;
        padding-right: 10px;
        border-radius: 2px;
    }
    button.small {
        height: 24px;
        font-size: 12px;
    }
    button:hover {
        border: 1px solid #AAA;
        background: #EEE;
        cursor: pointer;
    }
    button:hover:disabled,
    button[disabled]:hover {
        cursor: pointer;
        border: 1px solid #999;
        background: #DDD;
    }
    button:disabled i.fa-color,
    button[disabled] i.fa-color {
        color: #AAA;
    }
    button:hover:disabled i.fa-color,
    button[disabled]:hover i.fa-color {
        color: #AAA;
    }

    button.raised {
        border: 1px solid #999;
        background: #B8B8B8;
    }
    button.raised:hover {
        border: 1px solid #999;
        background: #DDD;
        cursor: pointer;
    }

    .fa.fa-green {
        color: #3AB882;
    }
    .fa.fa-yellow {
        color: #ecb534;
    }
    .fa.fa-red {
        color: #B83A82;
    }
    .fa.fa-blue {
        color: #3A82B8;
    }
    .fa.fa-purple {
        color: #B882B8;
    }
    .fa.fa-light-blue {
        color: #8AA2D8;
    }
    .fa.fa-orange {
        color: #DA7278;
    }
    .fa.fa-orange {
        color: #DA7278;
    }
</style>


// WEBPACK FOOTER //
// src/Components/Widget/PsButton.vue